import { render, staticRenderFns } from "./seljgbm.vue?vue&type=template&id=0afc7a57"
import script from "./seljgbm.vue?vue&type=script&lang=js"
export * from "./seljgbm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports